module.exports = __webpack_public_path__ + "img/sector_minus.124845b3.svg";